export const GRID_SPACE_GAPS_PERCENTAGE = 6;
export const GRID_SPACE_CONTENT_PERCENTAGE = 100 - GRID_SPACE_GAPS_PERCENTAGE;
